var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRiskClay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_941_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.152 308C142.495 308 141.152 306.657 141.152 305L141.152 140.931C141.152 139.274 139.809 137.931 138.152 137.931H115.099C112.315 137.931 111.033 134.468 113.145 132.655L254.046 11.6779C255.17 10.7128 256.83 10.7128 257.954 11.6779L398.855 132.655C400.967 134.468 399.685 137.931 396.901 137.931H373.848C372.191 137.931 370.848 139.274 370.848 140.931V305C370.848 306.657 369.505 308 367.848 308H144.152Z",
    stroke: "#062134",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 349C10 326.356 28.3563 308 51 308H461C483.644 308 502 326.356 502 349V499C502 501.761 499.761 504 497 504H15C12.2386 504 10 501.761 10 499V349Z",
    stroke: "#062134",
    strokeWidth: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5 316.5L66 358L122 384L96.5 401.5M231.5 316.5L265.5 358L217 411L240.5 433L221.5 468M397 316.5L371.5 348.5L411.5 401.5L363.5 429L397 451.5M311 302.5L292.5 256L311 240.5L284.5 193.5M284.5 193.5L317 136L338.5 125M284.5 193.5L247.5 158.5L227 167.5L205.5 136",
    stroke: "#062134",
    strokeWidth: 14,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_941_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRiskClay);
export default __webpack_public_path__ + "static/media/ico_risk_clay.8e62bc512aec130514b13a11e4dc43e4.svg";
export { ForwardRef as ReactComponent };